import { Box } from "@mui/material";
import dayjs from "../../dayjs";
import { useSearchParamState } from "use-search-param-state";
import MonthPicker from "../../components/monthPicker/MonthPicker";
import { startOfPreviousMonth } from "../../misc/dateUtils";

export function MonthFilter() {
  const [monthParam, setParam] = useSearchParamState("month", "");
  const month = monthParam ? dayjs(monthParam, "YYYY-MM") : startOfPreviousMonth();
  return (
    <Box
      sx={{
        flexBasis: "20%",
      }}
    >
      <MonthPicker
        value={month}
        onChange={(v) => {
          if (v) {
            setParam(v.format("YYYY-MM"));
          }
        }}
      />
    </Box>
  );
}
